var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 19.1668V10.0002C1.75 8.27133 1.75 7.40783 2.28717 6.87066C2.82433 6.3335 3.68783 6.3335 5.41667 6.3335C7.1455 6.3335 8.009 6.3335 8.54617 6.87066C9.08333 7.40783 9.08333 8.27133 9.08333 10.0002",
    stroke: "#FDF7E7",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5834 19.1667V13.6667C14.5834 11.9378 14.5834 11.0743 14.0462 10.5372C13.5091 10 12.6456 10 10.9167 10H9.08341C7.35458 10 6.49108 10 5.95391 10.5372C5.41675 11.0743 5.41675 11.9378 5.41675 13.6667V19.1667",
    stroke: "#FDF7E7",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2501 19.1667V6.12433C18.2501 4.896 18.2501 4.28091 17.9237 3.80975C17.5974 3.33858 17.0217 3.12225 15.8704 2.69141C13.62 1.84716 12.4952 1.4255 11.706 1.97183C10.9167 2.52 10.9167 3.72083 10.9167 6.12433V10",
    stroke: "#FDF7E7",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66671 6.3335V4.9585C2.66671 4.09408 2.66671 3.66233 2.93529 3.39375C3.20387 3.12516 3.63562 3.12516 4.50004 3.12516H6.33337C7.19779 3.12516 7.62954 3.12516 7.89812 3.39375C8.16671 3.66233 8.16671 4.09408 8.16671 4.9585V6.3335M5.41671 2.66683V0.833496M19.1667 19.1668H0.833374M8.16671 12.7502H11.8334M8.16671 15.5002H11.8334",
    stroke: "#FDF7E7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCity);
export default __webpack_public_path__ + "static/media/city.31cf3bb4de002492dfb3d5a75f02852d.svg";
export { ForwardRef as ReactComponent };